import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/order-campaign';

export class OrderCampaignService extends RestServiceConnection {
    listOrderCampaigns = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getOrderCampaignById = async (orderCampaignId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { orderCampaignId },
        }, true) as AxiosResponse;
        return this;
    }

    createOrderCampaign = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: values,
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }

    addContract = async (orderCampaignId: string, contractId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-contract',
            data: { orderCampaignId, contractId },
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }

    listOrderCampaignContracts = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-contracts',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getStageCalls = async (orderCampaignId: string, stage: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/stage-calls',
            data: { orderCampaignId, stage },
        }, true) as AxiosResponse;
        return this;
    }

    finishOrderCampaign = async (orderCampaignId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/finish',
            data: { orderCampaignId },
        }, true) as AxiosResponse;
        return this;
    }

    cancelOrderCampaign = async (orderCampaignId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/cancel',
            data: { orderCampaignId },
        }, true) as AxiosResponse;
        return this;
    }

    changeContractStage = async (orderCampaignId: string, contractId: string, stage: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/change-contract-stage',
            data: { orderCampaignId, contractId, stage },
        }, true) as AxiosResponse;
        return this;
    }

    markContractCallAsRealized = async (
        orderCampaignId: string,
        contractId: string,
        realized = true,
        classificationId?: string,
        notes?: string,
        scheduledAt?: string | null,
    ) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/mark-contract-call-realized',
            data: { orderCampaignId, contractId, realized, classificationId, notes, scheduledAt },
        }, true) as AxiosResponse;
        return this;
    }

    listCallClassifications = async () => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-call-classifications',
            data: {},
        }, true) as AxiosResponse;
        return this;
    }

    secureContracts = async (orderCampaignId: string, contractIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/secure-contracts',
            data: { orderCampaignId, contractIds },
        }, true) as AxiosResponse;
        return this;
    }

    reassignContractsUser = async (orderCampaignId: string, contractIds: string[], userId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/reassign-contracts-user',
            data: { orderCampaignId, contractIds, userId },
        }, true) as AxiosResponse;
        return this;
    }
}
